const Request = require('./BaseRequest')
const SendibleGraph = require('../graph/SendibleGraph')

module.exports = class SendibleRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new SendibleGraph(this.apiDomain)
    }

    swrSetupLink(token)
    {
        let args = {token: token}

        let { type, query } = this.graph.linkQuery(['id', 'token', 'expire'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    async setupLink(token)
    {
        let args = { token: token }
        let { type, query } = this.graph.linkQuery(['id','token','expire'])
        let data = await this.graph.request(query, args, type, true)
        return data
    }

}